import { IconProps } from 'src/utils/icon';

const ExclamationIcon: React.FC<IconProps> = ({
  size = 1,
  fill = '#2c2a29',
}) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.5625 14C27.5625 21.492 21.4898 27.5625 14 27.5625C6.51016 27.5625 0.4375 21.492 0.4375 14C0.4375 6.51235 6.51016 0.4375 14 0.4375C21.4898 0.4375 27.5625 6.51235 27.5625 14ZM14 16.7344C12.6107 16.7344 11.4844 17.8607 11.4844 19.25C11.4844 20.6393 12.6107 21.7656 14 21.7656C15.3893 21.7656 16.5156 20.6393 16.5156 19.25C16.5156 17.8607 15.3893 16.7344 14 16.7344ZM11.6116 7.69202L12.0173 15.1295C12.0363 15.4775 12.324 15.75 12.6726 15.75H15.3274C15.676 15.75 15.9637 15.4775 15.9827 15.1295L16.3884 7.69202C16.4089 7.31609 16.1096 7 15.7331 7H12.2668C11.8904 7 11.5911 7.31609 11.6116 7.69202Z"
      fill={fill}
    />
  </svg>
);

export default ExclamationIcon;
